/**
 * page : 이용안내
 */
import { useEffect } from "react";
import { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Editor } from "@tinymce/tinymce-react";
import Parser from 'html-react-parser';
import * as zy from '../common/zeroyear-1.0.0';
let sessionStorage = window.sessionStorage;
const {kakao} = window;

export default function LocatePage () {
    const [admin, setAdmin] = useState(false);
    // 오시는길 Content01 Edit용, 조회용 변수 2개 선언
    const [oriContent, setOriContent] = useState('');
    const [contentEdit, setContentEdit] = useState('');
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const initMap = () => {
        let container = document.getElementById('map'); //지도를 담을 영역의 DOM 레퍼런스
        let options = { //지도를 생성할 때 필요한 기본 옵션
            center: new kakao.maps.LatLng(37.3465021, 126.976791), //지도의 중심좌표.
            level: 3 //지도의 레벨(확대, 축소 정도)
        };
        let map = new kakao.maps.Map(container, options); //지도 생성 및 객체 리턴
        let marker = new kakao.maps.Marker({ 
            position: map.getCenter() 
        }); 
        marker.setMap(map);
    };
    /**
     * close modal
     */
    const closeModal = () => {
        setContentEdit(oriContent);
        setShowModal(false);
    };
    /**
     * open modal
     */
    const openModal = () => { setShowModal(true); };
    const selectAll = () => {
        zy.select('selectGuide', ['2'],(item) => {
            let content = item[0].GUIDE_CONTENT.replace('{지도}', `<div id="map" className="gg-map"></div>`);
            setContent(content);
            setContentEdit(item[0].GUIDE_CONTENT);
            setOriContent(item[0].GUIDE_CONTENT);
            initMap();
        });
    };
    /**
     * content change hanlder
     */
    const setContentEditChange = (data) => {
        setContentEdit(data||'');
    };
    const btnContentSave = () => {
        zy.modify('updateGuide', [contentEdit, '2'],(item) => {
            selectAll();
            closeModal();
        });
    };
    useEffect(() => {
        selectAll();
        // initMap();
        setAdmin(sessionStorage.getItem('isLogin'));
    }, [content]);
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">회사소개</a></li>
                        <li>오시는길</li>
                    </ol>
                    <h2>오시는길</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    {/* <div id="map" style={{ width: '100%', height: '500px'}}></div> */}
                    <div className="col-lg-12">
                        {admin ? <button className="btn-cancel" onClick={openModal}>수정</button> : null}
                        <div className="portfolio-info ori-table">
                            {Parser(content)}
                        </div>
                    </div>
                </div>
            </section>
            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>수정</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Editor
                        apiKey={'g473ctmydd0wpefxozp61yzmmfhdzfkv7o2m6czhrwe9b1ct'}
                        value={contentEdit}
                        id='tinyMce_editor'
                        init={{
                            height: 600,
                            menubar: false,
                            plugins: [
                                'lists',
                                'link',
                                'image',
                                'charmap',
                                'preview',
                                'searchreplace',
                                'fullscreen',
                                'media',
                                'table',
                                'code',
                                'help',
                                'emoticons',
                                'codesample',
                                'quickbars',
                            ],
                            toolbar:
                                'undo redo | blocks | ' +
                                'lists table link charmap searchreplace | ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'bold italic forecolor | alignleft aligncenter ' +
                                'image media codesample emoticons fullscreen preview | ' +
                                'removeformat | help ',
                        }}
                        onEditorChange={setContentEditChange}
                    />
                    <Modal.Footer>
                        <button className="btn-cancel" onClick={closeModal}>닫기</button>
                        <button className="btn-normal" onClick={btnContentSave}>등록완료</button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
        </main>
        </>
    );
}
